import { Image, Typography } from "antd";
import styles from "./AppLogo.module.less";
import { getWindowEnv } from "~/helpers/envConfig";

function AppLogo() {
  const { XSIGHT_VERSION } = getWindowEnv();
  return (
    <div className={styles.AppLogo}>
      <Image
        className={styles.image}
        preview={false}
        height={50}
        src="/images/mike.png"
      />

      <div className={styles.wrapper}>
        <div className={styles.titleWrapper}>
          <Typography.Title level={1} className={styles.copilot}>
            Ladle Copilot
          </Typography.Title>

          <Typography.Title
            level={5}
            className={styles.version}
            // eslint-disable-next-line no-console
            onClick={() => console.log(XSIGHT_VERSION)}
          >
            {/* {`(${XSIGHT_VERSION})`} */}
            {`(Beta)`}
          </Typography.Title>
        </div>

        <Typography.Title level={4} className={styles.name}>
          Mike
        </Typography.Title>
      </div>
    </div>
  );
}

export default AppLogo;
